<script setup lang="ts">
import { MAX_SECTOR_DEPTH } from "~/modules/sector/constants";
import { DropdownActions } from "~/modules/sector/models/DropdownActions.enum";
import ILxcEdit2 from "~icons/lxc/edit-2";
import ILxcFolderPlus from "~icons/lxc/folder-plus";
import ILxcMoreVertical from "~icons/lxc/more-vertical";
import ILxcTrash2 from "~icons/lxc/trash-2";

defineProps<{
  isRootSector?: boolean;
  sectorDepth: number;
}>();

const { t } = useI18n();
const emits = defineEmits(["create", "update", "remove"]);

const onCommand = (command: string) => {
  switch (command) {
    case DropdownActions.CREATE:
      emits("create");
      break;
    case DropdownActions.UPDATE:
      emits("update");
      break;
    case DropdownActions.REMOVE:
      emits("remove");
      break;
  }
};
</script>

<template>
  <lxc-dropdown-menu @command="onCommand">
    <template #menu-button>
      <span
        :title="t('sectors.treeview.actionsButton.title')"
        class="cursor-pointer"
      >
        <i-lxc-more-vertical />
      </span>
    </template>
    <lxc-dropdown-item
      v-if="sectorDepth < MAX_SECTOR_DEPTH"
      :command="DropdownActions.CREATE"
    >
      <div class="flex gap-2 items-center">
        <span><i-lxc-folder-plus class="w-4 h-4" /></span>
        <span>{{ t("sectors.button.newSub") }}</span>
      </div>
    </lxc-dropdown-item>
    <lxc-dropdown-item v-if="!isRootSector" :command="DropdownActions.UPDATE">
      <div class="flex gap-2 items-center">
        <span><i-lxc-edit-2 class="w-4 h-4" /></span>
        <span>{{ t("sectors.button.update") }}</span>
      </div>
    </lxc-dropdown-item>
    <lxc-dropdown-item v-if="!isRootSector" :command="DropdownActions.REMOVE">
      <div class="flex gap-2 items-center">
        <span><i-lxc-trash-2 class="w-4 h-4" /></span>
        <span>{{ t("sectors.button.remove") }}</span>
      </div>
    </lxc-dropdown-item>
  </lxc-dropdown-menu>
</template>
